<script>
    export default {
        props: {
            showElement: {
                type: Boolean,
                default: false,
            },
            eventName: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                elementShown: this.showElement,
            };
        },
        mounted() {
            // Show/hide the element based on the event
            VueEvents.$on(this.eventName, show => {
                this.elementShown = show;
            });
        },
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/mixins/HidableElement.vue